// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3PY4_","modalFooterButton":"ModalNotes_modalFooterButton__3t-0n"};